<template>
  <div class="tile">
    <button class="inner" @click="$emit('hitClick', tile)" :class="tileClass">
      {{tile.health}}
      <div class="multiplier" :class="{'show': tile.multiplier > 1}">+{{tile.multiplier}}</div>
      <div class="multiplier power-up-icon" :class="{'show': tile.multiplier === -1}"><i class="fas fa-dice"></i></div>
      <div class="multiplier-bonus" :class="{'show': tile.health <= 0}">{{tile.bonusPoint}}</div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'tile',
  props: ['tile', 'color', 'damage', 'bonusPoint'],
  methods: {
  },
  computed: {
    tileClass() {
      const classes = [this.color];
      // {'low-health': tile.health < 4 && tile.health > 0, 'dead': !tile.alive}

      // if (this.tile.health <= (parseFloat(this.damage) * 2)) classes.push('low-health');
      if (this.tile.health <= parseFloat(this.damage)) classes.push('dying');

      if (!this.tile.alive) classes.push('dead');

      return classes;
    },
  },
};
</script>


<style lang="less">
@import (reference) '~@/styles/colors.less';

.game.animate {
  .tile .inner {
    transition: all ease .3s;

    .multiplier .multiplier-bonus {
      transition: all ease .3s;
    }

    &.dead {
      .multiplier-bonus {
        animation: fade .7s ease;
      }
    }
  }
}

.tile {
  width: 100%/7;
  height: 100%/8;
  padding: .25rem;
  padding-bottom: (0.5rem);
  color: #fff;
  touch-action: manipulation;
  position: relative;
  .inner {
    touch-action: manipulation;
    background: #aaa;
    height: 100%; // font-size: .75rem;
    font-size: 1rem;
    font-weight: 700;
    display: flex;
    color: #fff;
    margin: 0;
    padding: 0;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    user-select: none;
    opacity: 1;
    position: relative;
    border-radius: 5px;
    width: 100%;
    display: block;
    border: none;
    box-shadow: 0 5px 0 darken(#aaa, 15%);
    touch-action: manipulation;

    &.secret {
      color: transparent;
    }

    &.re {
      .color(@red);
    }
    &.pi {
      .color(@pink);
    }

    &.pu {
      .color(@purple);
    }

    &.depu {
      .color(@deep-purple)
    }

    &.in {
      .color(@indigo);
    }

    &.bl {
      .color(@blue);
    }

    &.libl {
      .color(@light-blue);
    }

    &.cy {
      .color(@cyan);
    }

    &.te {
      .color(@teal);
    }

    &.gr {
      .color(@green);
    }

    &.ligr {
      .color(@light-green);
    }

    &.li {
      .color(@lime);
      color: #333;
    }

    &.ye {
      .color(@yellow);
      color: #333;
    }

    &.am {
      .color(@amber);
    }

    &.or {
      .color(@orange);
    }

    &.deor {
      .color(@deep-orange);
    }
    &.br {
      .color(@brown);
    }
    &.gra {
      .color(@gray);
    }
    &.blgr {
      .color(@blue-gray);
    }

    &.wh {
      .color(@white);
      color: #333;
    }

    &.mc {
      background: url('~@/assets/minecraft-block-default.jpg');
      background-position: top;
      background-size: cover;
      color: #fff;
      box-shadow: 0 5px 0 #613b2a;
      border-radius: 0;

      &.dying {
        background-image: url('~@/assets/minecraft-block.jpg');
      }
    }

    .color(@color) {
      background: @color;
      box-shadow: 0 5px 0 darken(@color, 20%);
      &.low-health {
        background: darken(@color, 10%);
      }
      &.dying {
        background: darken(@color, 15%);
      } // &:hover {
      //   background: lighten(@color, 5%);
      // }
    }

    .multiplier {
      position: absolute;
      top: -2.5px;
      right: -2.5px;
      border-radius: 50%;
      background: #fff;
      color: #333;
      font-size: .5rem;
      line-height: .5rem;
      padding: .25rem .2rem;

      @media(min-width: 320px) {
        padding: .45rem .4rem;
      }

      opacity: 0;
      transform: scale(0,
      0);

      &.show {
        opacity: 1;
        transform: scale(1, 1);
      }

      &.power-up-icon {
        padding: .30rem .2rem;
        i {
          font-size: 12px;
        }
      }
    }

    .multiplier-bonus {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 25px;
      height: 25px;
      margin-left: -12.5px;
      margin-top: -12.5px;
      border-radius: 50%;
      background: #fff;
      color: #333;
      font-size: .5rem;
      line-height: .5rem;
      display: flex;
      justify-content: center;
      align-items: center;

      opacity: 1;
      z-index: 6;
      transform: scale(0, 0); // &.show {
      //   opacity: 1;
      //   transform: scale(1, 1);
      // }
    }

    &.dead {
      background: #333 !important;
      box-shadow: 0 5px 0 #333 !important;
      color: transparent;
      cursor: default;
      .multiplier {
        opacity: 0;
        transform: scale(2, 2);
      }

      .multiplier-bonus {
        //animation: fade .7s ease;
      }
    }
  }
}

@keyframes fade {
  0%,
  100% {
    opacity: 0;
    transform: scale(1, 1);
  }
  50% {
    opacity: 1;
    transform: scale(1.5, 1.5) translateY(-100%);
  }
}
</style>



// WEBPACK FOOTER //
// Tile.vue?22ad516c